import React from "react";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import useStyles from "./LTDCModelerGlobal.styles";
import WhatWeDo from "../../whatWeDo/WhatWeDo.component";
import { HedgeRatioProvider } from "../../../context/HedgeRatioContext";
import { TreasuryKRISummaryProvider } from "../../../context/TreasuryKRISummaryContext";
import LTDCModelerGlobalFiltersAndReports from "./LTDCModelerGlobalFiltersAndReports.component";
import { ApprovalProvider } from "../../../context/ApprovalContext";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  padding: theme.spacing(2),
  textAlign: "center",
  color: theme.palette.text.primary,
}));

const LTDCModelerGlobal = ({ toCompare = false } = {}) => {
  const { classes } = useStyles();

  return (
    <div className={classes.page}>
      <Grid container item spacing={2}>
        <HedgeRatioProvider>
          <TreasuryKRISummaryProvider>
            <ApprovalProvider>
              <LTDCModelerGlobalFiltersAndReports
                toSave={true}
                toCompare={toCompare}
              />
            </ApprovalProvider>
          </TreasuryKRISummaryProvider>
        </HedgeRatioProvider>

        <Grid size={{ xs: 12, md: 12 }} sx={{ display: "none" }}>
          <Item>
            <WhatWeDo />
          </Item>
        </Grid>
      </Grid>
    </div>
  );
};

export default LTDCModelerGlobal;
